import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ComparisonTablePanel from '../reusable/ComparisonTablePanel';

/**
 * CommercialComparisonTable.
 * Comparison table.
 *
 * @author  Manny
 * @param   {Array}       props.addons          Product data.
 * @param   {Object}      props.industryPackage List of packages for the industry.
 * @param   {Array}       props.isMobile        Determines if tables are for mobile format.
 * @param   {Array}       props.packageKey      Name of the package.
 * @param   {Boolean}     props.propertyData    Product data.
 * @param   {Array}       props.tools           Product data.
 * @param   {String}      props.usersGeo        List of information on product's users and geography.
 * @returns {JSX.Element} The component markup.
 */

const CommercialComparisonTable = ({
  addons,
  industryPackage,
  isMobile = false,
  packageKey,
  propertyData,
  tools,
  usersGeo
}) => {
  const [openPanels, setOpenPanels] = useState([true, false, false, false]);

  const togglePanel = (index) => {
    let newOpen = [...openPanels];
    newOpen[index] = !newOpen[index];
    setOpenPanels(newOpen);
  };

  const panelContent = [
    {
      data: usersGeo,
      dataType: 'users_geo',
      iconType: 'usersIcon',
      tableType: 'data',
      title: 'Users '
    },
    {
      data: propertyData,
      dataType: 'property_data',
      iconType: 'propertyDataIcon',
      tableType: 'icon',
      title: 'Property Data '
    },
    {
      data: tools,
      dataType: 'tools',
      iconType: 'toolIcon',
      tableType: 'icon',
      title: 'Tools + Functionality '
    },
    {
      data: addons,
      dataType: 'addons',
      iconType: 'addonsIcon',
      tableType: 'icon',
      title: 'Add-Ons '
    }
  ];

  return (
    <div className={isMobile ? '' : 'margin-top'}>
      {panelContent.map((content, index) => (
        <ComparisonTablePanel
          data={content.data}
          dataType={content.dataType}
          defaultExpanded={index < 1 ? true : false}
          iconType={content.iconType}
          index={index}
          industryPackage={industryPackage}
          isOpen={openPanels[index]}
          isMobile={isMobile}
          key={`panel_key_${index}`}
          onClick={togglePanel}
          packageKey={packageKey}
          tableType={content.tableType}
          title={content.title}
        />
      ))}
    </div>
  );
};

CommercialComparisonTable.propTypes = {
  addons: PropTypes.array,
  industryPackage: PropTypes.object.isRequired,
  propertyData: PropTypes.array.isRequired,
  tools: PropTypes.array.isRequired,
  isMobile: PropTypes.bool,
  usersGeo: PropTypes.array.isRequired,
  packageKey: PropTypes.string
};

export default CommercialComparisonTable;
